import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import { useLocale } from '../LocaleProvider';

function number(value) {
  return value === null || value === undefined ? '—' : Number(value).toLocaleString('pt-BR', { maximumFractionDigits: 1 });
}

const TREND_STYLE = {
  up: { icon: 'TrendingUp', color: 'var(--success)', bg: 'var(--success-tint)' },
  down: { icon: 'TrendingDown', color: 'var(--miss)', bg: 'var(--miss-tint)' },
  stable: { icon: null, color: 'var(--accent)', bg: 'var(--accent-tint)' },
  insufficient: { icon: null, color: 'var(--ink-2)', bg: 'var(--hover)' },
};

export default function PatientStats({ stats = {} }) {
  const { locale } = useLocale();
  const es = locale === 'es';
  const trend = stats.trend || { direction: 'insufficient', label: 'dados insuficientes', delta: null };
  const trendDelta = trend.delta === null || trend.delta === undefined
    ? ''
    : ` (${trend.delta > 0 ? '+' : ''}${number(trend.delta)} ${es ? (Math.abs(trend.delta) === 1 ? 'punto' : 'puntos') : (Math.abs(trend.delta) === 1 ? 'ponto' : 'pontos')})`;
  const trendStyle = TREND_STYLE[trend.direction] || TREND_STYLE.insufficient;

  const count = stats.count ?? 0;

  return (
    <section aria-label={es ? 'Resumen de las evaluaciones' : 'Resumo das avaliações'} className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <p className="text-xs font-semibold text-[var(--text-muted)]">{es ? 'Promedio' : 'Média'}</p>
        <p className="mt-1 flex flex-wrap items-baseline gap-x-2">
          <span className="font-display text-[length:var(--fs-40)] leading-none text-[var(--primary)]">{number(stats.average)}</span>
          <span className="text-sm text-[var(--text-muted)]">{es ? `de 30, en ${count} ${count === 1 ? 'evaluación' : 'evaluaciones'}` : `de 30, em ${count} ${count === 1 ? 'avaliação' : 'avaliações'}`}</span>
        </p>
        <p className="mt-2 text-sm" style={{ color: trendStyle.color }}>
          {trendStyle.icon && <SafeIcon name={trendStyle.icon} className="mr-1 inline-block h-3.5 w-3.5 align-[-2px]" />}
          <strong className="font-semibold">{es ? 'Tendencia:' : 'Tendência:'}</strong> {es ? (trend.direction === 'up' ? 'ascendente' : trend.direction === 'down' ? 'descendente' : trend.direction === 'stable' ? 'estable' : 'datos insuficientes') : trend.label}{trendDelta}
        </p>
      </div>
      <dl className="flex gap-x-6 gap-y-1 text-sm">
        <div><dt className="text-[var(--text-muted)]">{es ? 'Mediana' : 'Mediana'}</dt><dd className="font-semibold text-[var(--primary)]">{number(stats.median)}</dd></div>
        <div><dt className="text-[var(--text-muted)]">{es ? 'Mínimo' : 'Menor'}</dt><dd className="font-semibold text-[var(--primary)]">{number(stats.minimum)}</dd></div>
        <div><dt className="text-[var(--text-muted)]">{es ? 'Máximo' : 'Maior'}</dt><dd className="font-semibold text-[var(--primary)]">{number(stats.maximum)}</dd></div>
      </dl>
    </section>
  );
}
